import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { track } from "@/lib/track";

export default function ReviewCta({ pathway }) {
  const { review } = pathway;
  return (
    <section className="mt-10 text-center" data-testid="review-cta-section">
      <p className="text-base sm:text-lg text-slate-700 leading-relaxed max-w-xl mx-auto font-medium">{review.question}</p>
      <p className="mt-2 text-sm text-slate-500">Your review is complimentary and there's no obligation.</p>
      <Link
        to={`/book/${pathway.bookingKey}`}
        onClick={() => {
          track("booking_clicked", pathway.key);
          api.post("/appointments/request", { lead_id: null, note: pathway.label }).catch(() => {});
        }}
        data-testid="schedule-consultation-button"
        className="mt-5 w-full min-h-[60px] rounded-full btn-gold-luxe text-navy font-extrabold text-sm sm:text-base tracking-widest transition-all hover:-translate-y-0.5 flex items-center justify-center gap-2 px-4"
      >
        {review.cta} <ArrowRight className="w-5 h-5 shrink-0" />
      </Link>
      <p className="mt-3 text-xs font-semibold tracking-widest uppercase text-slate-400">Choose a time that works for you.</p>
    </section>
  );
}
